'use client';

import { useEffect, useState } from 'react';
import cn from 'classnames';

import { TextPassage } from '@petsmart-ui/sparky';

import { getAccessToken } from '@libs/api-proxy-client';
import { ErrorBoundary, LegacyIcon, LegacyIconName, useLoyaltyContext, useUserSession } from '@libs/common-next';

import { SignIn, LoggedIn, Loading } from './components';
import './LegacyAccountDropdown.scss';

const useAccountDropdown = () => {
    const { memberPoints } = useLoyaltyContext();
    const { storageUserSession, ocapi, userData } = useUserSession();

    const [loyaltyPoints, setLoyaltyPoints] = useState<number>(0);
    const [firstName, setFirstName] = useState<string>('');

    const isLoggedIn = Boolean(getAccessToken()) || Boolean(memberPoints?.firstName);
    const isLoadingUserProfile = isLoggedIn && !userData?.profile?.firstName;
    const isLoadingGuest = ocapi.isLoading && !isLoggedIn;
    const isLoading = ocapi.isLoading || isLoadingUserProfile || isLoadingGuest;

    useEffect(() => {
        const currentFirstName = userData?.profile?.firstName || memberPoints?.firstName;
        const currentLoyaltyPoints = memberPoints?.availablePoints ?? storageUserSession?.loyaltyPoints;

        setFirstName(currentFirstName?.trim() ?? '');
        setLoyaltyPoints(currentLoyaltyPoints ?? 0);
    }, [
        ocapi.isLoading,
        userData?.profile?.firstName,
        memberPoints?.availablePoints,
        storageUserSession?.loyaltyPoints,
    ]);

    return {
        isLoading,
        firstName,
        loyaltyPoints,
    };
};

export default function LegacyAccountDropdown() {
    const { isLoading, firstName, loyaltyPoints } = useAccountDropdown();

    return (
        <div className={cn('legacy-account')}>
            <div className={cn('legacy-account__inner')}>
                <div className="legacy-account__icon-box">
                    <LegacyIcon isPriority size={45} className="icon" name={LegacyIconName.TREATS_NEW_LG} />
                </div>

                <div className="legacy-account__action">
                    <div className="legacy-account__title">
                        {isLoading && <Loading />}

                        {!isLoading && firstName && <LoggedIn firstName={firstName} loyaltyPoints={loyaltyPoints} />}

                        {!isLoading && !firstName && (
                            <ErrorBoundary>
                                <SignIn />
                            </ErrorBoundary>
                        )}
                    </div>

                    <TextPassage className="legacy-account__sub">Rewards &amp; Account</TextPassage>
                </div>
            </div>
        </div>
    );
}
